import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../Context';
import { AuthContextApi } from '../../Context/api';
import { UsersIcon, PlusIcon } from '@heroicons/react/24/outline'
import CardMetricas from '../../Components/Cards/Metricas';
import Header from '../../Components/Header';
import FormBusca from '../../Components/Forms/Busca';
import InvestidoresTable from '../../Components/Table/Investidores';
import ModalInvestidor from '../../Components/Modal/Investidores';
import VisualizacaoInvestidor from '../../Components/Modal/Investidores/Visualizacao';


const Investidores = () => {
    const { states, setters } = useContext(AuthContext)
    const { checkLogin, getInvestidoresDataSistema, getInvestidores,
        postInvestidores,
        patchInvestidores,
        bloquearDesbloquearInvestidores } = useContext(AuthContextApi)

    const [searchTerm, setSearchTerm] = useState('')
    const [selectedFilterField, setSelectedFilterField] = useState('email')
    const [selectedSortField, setSelectedSortField] = useState('data_criacao')
    const [sortDirection, setSortDirection] = useState('desc')
    const [recordsPerPage, setRecordsPerPage] = useState(10)

    const filterOptions = [
        { value: 'email', label: 'E-mail' },
        { value: 'nome', label: 'Nome' },
        { value: 'cpf', label: 'CPF' },
    ]

    const sortOptions = [
        { value: 'data_criacao', label: 'Data de Criação' },
        { value: 'data_atualizacao', label: 'Data de Atualização' },
        { value: 'nome', label: 'Nome' },
        { value: 'email', label: 'E-mail' },
    ]

    const buildParams = (overrides = {}) => new URLSearchParams({
        page: states.page || 0,
        per_page: recordsPerPage,
        sort: selectedSortField,
        sort_dir: sortDirection,
        filter: selectedFilterField,
        search: searchTerm,
        ...overrides,
    }).toString()

    const primeiroLoad = async () => {
        if (states.dataInvestidores.length > 0) return;
        await checkLogin()
        await getInvestidoresDataSistema()
        await getInvestidores(buildParams({ page: 0, search: '' }))
    }

    const search = async (data) => {
        await getInvestidores(new URLSearchParams({
            page: 0,
            per_page: data.recordsPerPage,
            sort: data.selectedSortField,
            sort_dir: data.sortDirection,
            filter: data.selectedFilterField,
            search: data.searchTerm || '',
        }).toString())
    }

    const clear = async () => {
        setters.setPage(0)
        await getInvestidores(buildParams({ page: 0, search: '', sort: 'data_criacao', sort_dir: 'desc', filter: 'email', per_page: 10 }))
    }


    const next = () => setters.setPage(states.page + 1)
    const previous = () => { if (states.page > 0) setters.setPage(states.page - 1) }

    const addInvestidor = () => {
        setters.setIsEdit(false)
        setters.setInvestidores({})
        setters.setModalInvestidores(true)
    }

    const editInvestidor = (data) => {
        setters.setIsEdit(true)
        setters.setInvestidores({ id: data.id, ...data })
        setters.setModalInvestidores(true)
    }

    const createInvestidorHandler = async (data) => {
        const response = await postInvestidores(data)
        if (response) {
            setters.setModalInvestidores(false)
            await getInvestidores(buildParams())
        }
    }

    const editInvestidorHandler = async (id, data) => {
        const response = await patchInvestidores(id, data)
        if (response) {
            setters.setModalInvestidores(false)
            setters.setIsEdit(false)
            await getInvestidores(buildParams())
        }
    }

    const viewInvestidor = (data) => {
        setters.setInvestidores(data)
        setters.setModalViewInvestidores(true)
    }

    const bloquearDesbloquearInvestidorHandler = async (data) => {
        setters.setModalMsg(true)
        setters.setMsgModalMsg(`Deseja mesmo ${data.bloqueado ? 'bloquear' : 'desbloquear'} o investidor ${data.nome}?`)
        setters.setDescModalMsg(`Após a confirmação o investidor será ${data.bloqueado ? 'bloqueado' : 'desbloqueado'}`)
        setters.setTitleButtonModalMsg('Confirmar')
        setters.setFunctionModalMsg(() => async () => {
            const resp = await bloquearDesbloquearInvestidores(data.id)
            if (resp) {
                setters.setModalMsg(false)
                await getInvestidores(buildParams())
            }
        })
    }

    useEffect(() => {
        primeiroLoad()
        return () => {
            setters.setDataEstatisticaInvestidores([])
            setters.setDataInvestidores([])
            setters.setPage(0)
        }
    }, [])

    useEffect(() => {
        if (states.dataInvestidores?.length === 0) return
        getInvestidores(buildParams())
    }, [states.page, recordsPerPage, selectedSortField, sortDirection])

    return (
        <>
            <Header
                title="Investidores"
                description="Gerencie a base de investidores do sistema"
                icon={UsersIcon}
                hasAction={true}
                hasReturn={false}
                buttonAction={addInvestidor}
                buttonText="Adicionar Investidor"
                buttonIcon={PlusIcon}
                buttonColor="green"
            />

            <div className="px-6 pt-5 pb-6">
                <CardMetricas dataMetricas={states.dataEstatisticaInvestidores} />

                <FormBusca
                    filterOptions={filterOptions}
                    sortOptions={sortOptions}
                    search={search}
                    handleClear={clear}
                    color="yellow"
                    haveData={states.dataInvestidores?.length > 0}
                    items={{
                        searchTerm, setSearchTerm,
                        selectedFilterField, setSelectedFilterField,
                        selectedSortField, setSelectedSortField,
                        sortDirection, setSortDirection,
                        recordsPerPage, setRecordsPerPage,
                    }}
                />

                <InvestidoresTable
                    data={states.dataInvestidores ?? []}
                    loading={states.isLoading}
                    page={states.page}
                    recordsPerPage={recordsPerPage}
                    next={next}
                    previous={previous}
                    editInvestidor={editInvestidor}
                    showInvestidor={viewInvestidor}
                    bloquearDesbloquearInvestidor={bloquearDesbloquearInvestidorHandler}
                />
            </div>

            <ModalInvestidor
                states={states}
                setters={setters}
                actionCreate={createInvestidorHandler}
                actionEdit={editInvestidorHandler}
            />
            <VisualizacaoInvestidor
                states={states}
                setters={setters}
            />
        </>
    )
}

export default Investidores;
